import Hero from "./sections/Hero/Hero";
import Procedimento from "./sections/Procedimento/Procedimento";
import ComoFunciona from "./sections/ComoFunciona/ComoFunciona";
import SobreClinica from "./sections/SobreClinica/SobreClinica";
import Depoimentos from "./sections/Depoimentos/Depoimentos";
import Resultados from "./sections/Resultados/Resultados";
import SobreTrabalho from "./sections/SobreTrabalho/SobreTrabalho";
import SobreDoutora from "./sections/SobreDoutora/SobreDoutora";
import Header from "./components/Header/Header";
import Footer from "./sections/Footer/Footer";

export default function App() {
  return (
    <div className="font-sans text-gray-800">
      <Header />
      <Hero />
      <Procedimento />
      <ComoFunciona />
      <Resultados />
      <SobreTrabalho />
      <SobreClinica />
      <Depoimentos />
      <SobreDoutora />
      <Footer />
    </div>
  );
}